module.exports = __webpack_public_path__ + "img/036-mailbox.b4dc1501.svg";